<template>
  <div class="telegram_destinations">
    <div class="wrap-device-list_bg">
      <div
          class="main_filters"
          :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
          @click="toggleFiltersState"
      >
        <span
            class="mdi"
            :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
        />
        <span class="main_fiters_toggler_text">
          {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
        </span>
      </div>
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <fg-input
            v-model="filter.q"
            :placeholder="translate('search')"
            :clearable="true"
            @input="change_input"
          />
        </div>
        <div class="form_select">
          <tree-select
            v-model="filter.is_active"
            :options="state_list"
            :placeholder="translate('telegram.state')"
            @input="change_input"
          />
        </div>
        <div class="form_select">
          <tree-select
            v-model="filter.client_id"
            :options="client_list"
            :placeholder="translate('telegram.recipient')"
            @input="change_input"
          />
        </div>
        <div class="form_select"></div>
        <div class="form_select">
          <button
              class="btn btn-success btn-fill mdi mdi-plus-circle-outline"
              @click.prevent="show_modal('create')"
          >
            {{ translate('telegram.create') }}
          </button>
        </div>
      </div>
    </div>
    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>
      <h3 v-else-if="!destination_list.length" class="text-center">{{ translate('no_data') }}</h3>
      <table v-else>
        <thead>
          <tr>
            <th
              v-for="column in columns"
              :key="column"
              scope="col"
            >
              {{ translate('telegram.' + column) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in destination_list"
            :key="item.id"
          >
            <td
              class="text-left"
              :data-label="translate('telegram.name')"
            >
              {{ item.name }}
            </td>
            <td data-label="Chat ID">
              {{ item.chat_id }}
              <span
                class="mdi mdi-content-copy pointer"
                @click="copy_chat(item.chat_id)"
              />
            </td>
            <td data-label="Thread ID">{{ item.thread_id || translate('telegram.no_thread') }}</td>
            <td :data-label="translate('telegram.recipient')">{{ recipient(item.client_id) }}</td>
            <td :data-label="translate('telegram.state')">
              {{ translate(active(item.is_active) ? 'telegram.active' : 'telegram.disabled') }}
            </td>
            <td
              class="actions"
              :data-label="translate('telegram.actions')"
            >
              <button
                v-if="active(item.is_active)"
                class="btn btn-info btn-fill"
                @click="show_modal('test', item)"
              >
                {{ translate('telegram.test') }}
              </button>
              <router-link
                class="btn btn-primary btn-fill"
                :to="{
                  path: '/notification/notification_routes',
                  query: {destination_id: item.id}
                }"
              >
                {{ translate('telegram.channel_routes') }}
              </router-link>
              <button
                v-if="active(item.is_active)"
                class="btn btn-danger btn-fill"
                @click="show_modal('disable', item)"
              >
                {{ translate('telegram.disable') }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination_controls" v-if="!loading">
      <span>{{ translate('telegram.total') }}: {{ total }}</span>
      <button
        class="btn btn-info btn-fill"
        :disabled="loading || filter.offset === 0"
        @click="change_page(Math.max(0, filter.offset - filter.limit))"
      >
        {{ translate('telegram.previous') }}
      </button>
      <span>{{ Math.floor(filter.offset / filter.limit) + 1 }}</span>
      <button
        class="btn btn-info btn-fill"
        :disabled="loading || filter.offset + filter.limit >= total"
        @click="change_page(filter.offset + filter.limit)"
      >
        {{ translate('telegram.next') }}
      </button>
      <tree-select
        v-model="filter.limit"
        :options="[50, 100, 250, 500].map((value) => ({id: value, label: String(value)}))"
        :clearable="false"
        :disabled="loading"
        @input="change_page(0)"
      />
    </div>
  </div>
</template>
<script>
import DestinationModal from './Modal/Index.vue'

export default {
  name: 'TelegramDestinations',
  data () {
    return {
      destination_list: [],
      total: 0,
      loading: true,
      timer: null,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      filter: {
        q: '',
        is_active: null,
        client_id: null,
        limit: 50,
        offset: 0
      },
      columns: ['name', 'chat_id', 'thread_id', 'recipient', 'state', 'actions']
    }
  },
  computed: {
    client_list() {
      return [
        {id: 0, label: this.translate('telegram.internal')},
        ...this.$store.getters.getClientsList.map((client) => ({
          id: Number(client.id),
          label: client.name
        }))
      ]
    },
    state_list() {
      return [
        {id: 1, label: this.translate('telegram.active')},
        {id: 0, label: this.translate('telegram.disabled')}
      ]
    },
    sended_filter() {
      let filter = {}
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key] !== '' && this.filter[key] !== null && this.filter[key] !== undefined) {
          filter[key] = this.filter[key]
        }
      })
      return filter
    }
  },
  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'notification_section') {
          let string = '?'
          for (let key in this.filter) {
            if (key === 'limit' || key === 'offset') continue
            if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
              string += '&' + key + '=' + encodeURIComponent(this.filter[key])
            }
          }
          history.replaceState(null, null, this.$route.path + string)
        }
      }
    },
  },
  created () {
    this.check_query()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    active(value) {
      return value === true || value === 1 || value === '1'
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_id':
            case 'is_active':
              this.filter[key] = Number(this.$route.query[key])
              break;
            case 'q':
              this.filter[key] = this.$route.query[key]
              break;
          }
        }
      }
      this.get_destinations()
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.filter.offset = 0
      this.timer = setTimeout(this.get_destinations, 500)
    },
    change_page(offset) {
      clearTimeout(this.timer)
      this.filter.offset = offset
      this.get_destinations()
    },
    get_destinations(){
      this.loading = true
      this.$http.v1.getTelegramDestinations(this.sended_filter, (response) => {
        if (response.data){
          this.destination_list = response.data.items
          this.total = response.data.total
          this.filter.limit = response.data.limit
          this.filter.offset = response.data.offset
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      }).finally(() => {
        this.loading = false
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
    recipient(client_id, name) {
      if (!client_id) return this.translate('telegram.internal')
      const client = this.$store.getters.getClientsList.find(
        (client) => String(client.id) === String(client_id)
      )
      return `${name || client?.name || this.translate('client.one')} #${client_id}`
    },
    copy_chat(value) {
      this.copy_to_clipboard(String(value))
      this.global_notify('info', this.translate('clipboard.value_save_buffer'))
    },
    show_modal(mode, channel) {
      let t = this.$createElement(DestinationModal, {
        props: {
          mode,
          channel,
          clients: this.client_list,
          recipient: channel ? this.recipient(channel.client_id) : ''
        },
        on: {
          close: () => this.$modal.hide('telegram-destination'),
          update: () => this.get_destinations()
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(
        temp,
        {},
        {
          height: 'auto',
          adaptive: true,
          clickToClose: false,
          scrollable: true,
          name: 'telegram-destination'
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.telegram_destinations {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
      .btn{
        width: 100%;
      }
    }
  }

  .response_table {
    flex: 10;
    padding: 10px 0 0;
    th,
    td {
      font-size: 12px;
      vertical-align: middle;
    }
    .text-left {
      text-align: left;
    }
    td p {
      margin: 0;
    }
    tbody tr:hover {
      background-color: #eee;
    }
    .actions .btn {
      margin: 2px;
    }
  }
  .pagination_controls {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-top: 10px;
    .vue-treeselect {
      width: 100px;
    }
  }
}
</style>
